import {
  appService,
  authService,
  userService,
  storageService,
  candidateService,
  checkupService,
  dashboardService,
  reportsService,
  storeService,
  scheduleCheckupService,
} from 'services';

export interface IApis {
  // authService
  login: any;
  logout: any;
  resetPassword: any;
  checkResetPasswordSessionToken: any;
  forgotPassword: any;
  refreshToken: any;

  // user
  getAllUser: any;
  addUser: any;
  deleteUser: any;
  sendPassword: any;
  sendResetPasswordLink: any;
  getFilteredUser: any;

  // app
  getAllZones: any;
  getAllCity: any;
  getCityByZone: any;
  addNewZone: any;
  addNewCity: any;

  //dashboard
  getDashboardData: any;

  // candidate
  getAllCandidates: any;
  getCandidate: any;
  getFilteredCandidates: any;
  downloadAllCandidates: any;
  downloadCandidateExcel: any;
  uploadCandidateExcel: any;
  addNewCandidates: any;
  editCandidate: any;
  updateStatus: any;

  // checkups
  getAllQsrCheckups: any;
  downloadCheckupStatusExcel: any;
  updateCheckupStatus: any;
  resendCheckupSMS: any;
  getFilteredCheckupStatus: any;

  // reports
  getAllReports: any;
  getFilteredReports: any;
  downloadReport: any;
  downloadFilteredReports: any;
  downloadCandidatesReports: any;

  // schedule-checkup
  getFilteredScheduleCheckups: any;
  getAllScheduleCheckup: any;
  downloadScheduleCheckupExcel: any;
  updateScheduleCheckupStatus: any;

  // stores
  addStore: any;
  getStores: any;
  getStoresDetails: any;
}

export default {
  ...appService,
  ...authService,
  ...userService,
  ...storageService,
  ...candidateService,
  ...checkupService,
  ...dashboardService,
  ...reportsService,
  ...storeService,
  ...scheduleCheckupService,
} as IApis;
